import {IncidentsState} from './incidents.state';
import {createReducer, on} from '@ngrx/store';
import {IncidentsActions} from './incidents.index';


const initialState: IncidentsState = {
  incidents: [],
  selectedIncident: undefined,
  documents: [],
  comments: []
};

const reducer = createReducer(
  initialState,
  on(
    IncidentsActions.LOAD_INCIDENTS,
    state => state
  ),
  on(
    IncidentsActions.LOAD_INCIDENTS_SUCCESS,
    (state, action) => ({
      ...state,
      incidents: action.incidents
    })
  ),
  on(
    IncidentsActions.SELECT_INCIDENT,
    state => state
  ),
  on(
    IncidentsActions.SELECT_INCIDENT_SUCCESS,
    (state, action) => ({
      ...state,
      selectedIncident: action.incident
    })
  ),
  on(
    IncidentsActions.LOAD_INCIDENT_DOCUMENTS,
    state => state
  ),
  on(
    IncidentsActions.LOAD_INCIDENT_DOCUMENTS_SUCCESS,
    (state, action) => ({
      ...state,
      documents: action.documents
    })
  ),
  on(
    IncidentsActions.LOAD_INCIDENT_COMMENTS,
    state => state
  ),
  on(
    IncidentsActions.LOAD_INCIDENT_COMMENTS_SUCCESS,
    (state, action) => ({
      ...state,
      comments: action.comments
    })
  ),
  on(
    IncidentsActions.ACCEPT_INCIDENT,
    state => state
  ),
  on(
    IncidentsActions.ACCEPT_INCIDENT_SUCCESS,
    state => state
  ),
  on(
    IncidentsActions.ADD_COMMENT,
    state => state
  ),
  on(
    IncidentsActions.ADD_COMMENT_SUCCESS,
    state => state
  ),
  on(
    IncidentsActions.INCIDENT_ACCEPT_CHANGE,
    state => state
  ),
  on(
    IncidentsActions.INCIDENT_ACCEPT_CHANGE_SUCCESS,
    state => state
  )
);

export function incidentsReducer(state: IncidentsState, action) {
  return reducer(state, action);
}
